<form [formGroup]="form" (ngSubmit)="onFormSubmit()">
  <div class="mb-4" *ngIf="customerPerson$ | async as member">
    <label class="form-label">
      {{ 'memberModule.member' | translate }}
    </label>
    <div
      >{{ member.id }} - {{ member.firstName }}{{ member.middleName }}
      {{ member.lastName }}</div
    >
  </div>
  <div class="mb-4" *ngIf="userRoles$ | async as userRoles">
    <label class="form-label">
      {{ 'userRoleModule.selectPurchaseUserRole' | translate }}
    </label>

    <ng-select
      [items]="userRoles$ | async"
      formControlName="userRoleId"
      [dropdownPosition]="'top'"
      bindValue="id"
      [searchFn]=""
      [clearable]="true"
    >
      <!-- for the selected item -->
      <ng-template ng-label-tmp let-item="item">
        <span *ngIf="item?.id">{{ item.id }}</span>
        <span *ngIf="item?.organizationId">
          -
          {{
            (organizationEntities$ | async)?.[item.organizationId]?.description
          }}
        </span>
        <span *ngIf="item?.roleId">
          - {{ (roleEntities$ | async)?.[item.roleId]?.description }}
        </span>
        <span *ngIf="item?.siteId">
          - {{ (siteEntities$ | async)?.[item.siteId]?.description }}
        </span>
      </ng-template>
      <!-- for the selectable item -->
      <ng-template ng-option-tmp let-item="item">
        <span *ngIf="item?.id">{{ item.id }}</span>
        <span *ngIf="item?.organizationId">
          -
          {{
            (organizationEntities$ | async)?.[item.organizationId]?.description
          }}
        </span>
        <span *ngIf="item?.roleId">
          - {{ (roleEntities$ | async)?.[item.roleId]?.description }}
        </span>
        <span *ngIf="item?.siteId">
          - {{ (siteEntities$ | async)?.[item.siteId]?.description }}
        </span>
      </ng-template>
    </ng-select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.userRoleId.dirty && form.controls.userRoleId.invalid"
    >
      {{ 'userRoleModule.userRole' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <!-- first select a product -->

  <div class="mb-4">
    <label class="form-label">
      {{ 'subscriptionModule.subscription' | translate }}
    </label>
    <product-select-input
      (search)="onSearchSubscriptions($event)"
      [products]="allSubscriptions$ | async"
      formControlName="subscriptionId"
      (productSelected)="subscriptionSelected($event)"
      [allowClearing]="true"
      [dropdownPosition]="'top'"
    ></product-select-input>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.subscriptionId.dirty &&
        form.controls.subscriptionId.invalid
      "
    >
      {{ 'subscriptionModule.subscription' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
  <div class="mb-4" [hidden]="!subscription || startDateErrorString">
    <label *ngIf="!(isDirectDebit$ | async)" class="form-label">
      {{ 'general.total' | translate }}
    </label>
    <label *ngIf="isDirectDebit$ | async" class="form-label">
      {{ 'general.details' | translate }}
    </label>

    <div class="mb-1 fw-bold">
      <span
        *ngIf="
          !(
            getPrice(
              subscription,
              customerPerson$ | async,
              false,
              configOption$ | async
            ) ||
            getPrice(
              subscription,
              customerPerson$ | async,
              false,
              configOption$ | async
            ) === 0
          )
        "
      >
        {{ 'subscriptionModule.priceNotAvailable' | translate }}
      </span>

      <span
        *ngIf="
          getPrice(
            subscription,
            customerPerson$ | async,
            false,
            configOption$ | async
          ) ||
          getPrice(
            subscription,
            customerPerson$ | async,
            false,
            configOption$ | async
          ) === 0
        "
        data-test-id="subscription-detail-card-simple-price"
      >
        {{
          getPrice(
            subscription,
            customerPerson$ | async,
            subsIsPayOnlyFirstTermOnDefEnDate$(subscription) | async,
            configOption$ | async
          ) | currency
        }}
      </span>
      <span [hidden]="subscription && subscription.defaultEndDate">
        /
        {{ subscriptionService.getDurationTranslation(subscription) | async }}
      </span>
      <span
        [hidden]="subscription && !subscription.defaultEndDate"
        data-test-id="subscription-detail-card-default-end-date"
      >
        {{ 'general.lowerCaseTillGerman' | translate }}
        {{
          (subscription?.defaultEndDate | momentParse)?.toDate()
            | date: 'dd/MM/yyyy'
        }}
      </span>

      <p *ngIf="subsIsPayOnlyFirstTermOnDefEnDate$(subscription) | async">
        <small
          *ngIf="
            getPrice(
              subscription,
              customerPerson$ | async,
              false,
              configOption$ | async
            ) ||
            getPrice(
              subscription,
              customerPerson$ | async,
              false,
              configOption$ | async
            ) === 0
          "
          data-test-id="subscription-detail-card-simple-price-term"
        >
          {{
            getPrice(
              subscription,
              customerPerson$ | async,
              false,
              configOption$ | async
            ) | currency
          }}
        </small>
        <small>
          /
          {{ subscriptionService.getDurationTranslation(subscription) | async }}
        </small>
      </p>
    </div>
    <div
      class="fw-bold"
      *ngIf="subscription && subscription.isFixedTerms"
      data-test-id="subscription-detail-card-recalculated-price"
    >
      {{ partialPrice | currency }}
      {{ 'saleModule.forCurrentMonth' | translate }}
    </div>
  </div>
  <div
    *ngIf="
      (sameSubscriptionSubscriber$ | async) &&
      !(sameSubscriptionSubscriber$ | async)?.endDate
    "
  >
    <div
      class="alert alert-danger"
      role="alert"
      aria-atomic="true"
      data-test-id="same-subscription-alert"
    >
      {{ 'saleModule.alreadyHaveAutorenewSubscriptionLikeThis' | translate }}
    </div>
  </div>
  <div
    *ngIf="
      !(sameSubscriptionSubscriber$ | async) ||
      (sameSubscriptionSubscriber$ | async)?.endDate
    "
  >
    <div *ngIf="sameSubscriptionSubscriber$ | async" class="mb-4">
      <div
        *ngIf="subscription && !subscription?.defaultStartDate"
        class="alert alert-danger"
        role="alert"
        aria-atomic="true"
        data-test-id="same-subscription-text"
      >
        {{ 'subscriptionModule.alreadyHaveASubscriptionLikeThis' | translate }}
        {{ 'subscriptionModule.clickToSubFollowCurrently' | translate }}
        <hr class="border-secondary" />
        <button
          type="button"
          *ngIf="subscription && !subscription?.defaultStartDate"
          (click)="$event.preventDefault(); setSameSubEndDateAsStartDate()"
          class="btn btn-soft-primary"
        >
          {{ 'subscriptionModule.setSameSubEndDateAsStartDate' | translate }}
        </button>
      </div>

      <div
        *ngIf="subscription && subscription.defaultStartDate"
        class="alert alert-danger"
      >
        {{
          'subscriptionModule.alreadyHaveASubscriptionLikeThisNotAllowed'
            | translate
        }}
      </div>
    </div>
    <div
      *ngIf="maxSimultaneousHasBeenReached"
      role="alert"
      aria-atomic="true"
      class="alert alert-danger"
    >
      {{
        'subscriptionModule.alreadyHaveASubscriptionLikeThisNotAllowed'
          | translate
      }}
    </div>
    <div
      *ngIf="
        !(sameSubscriptionSubscriber$ | async) &&
        subscription &&
        subscription.defaultStartDate &&
        !maxSimultaneousHasBeenReached
      "
      class="mb-4"
    >
      <div *ngIf="subscription && subscription.defaultStartDate">
        {{ 'general.startDate' | translate }}:
        {{
          subscriptionService.getStartDate(subscription.defaultStartDate)
            | date: 'dd/MM/yyyy'
        }}
      </div>
      <div [hidden]="subscription && !subscription.isAutoRenew">
        <ng-container
          *ngIf="subscription.defaultEndDate || subscription.defaultStartDate"
        >
          {{ 'general.endDate' | translate }}:
          <span *ngIf="subscription && subscription.defaultEndDate">
            {{
              (subscription?.defaultEndDate | momentParse)?.toDate()
                | date: 'dd/MM/yyyy'
            }}
          </span>
          <span *ngIf="subscription && !subscription.defaultEndDate">
            {{
              subscriptionService.getEndDate(
                subscription.defaultStartDate,
                subscription
              ) | date: 'dd/MM/yyyy'
            }}
          </span>
        </ng-container>
      </div>
    </div>
    <div *ngIf="!maxSimultaneousHasBeenReached && isAvailable">
      <div class="row">
        <div
          *ngIf="subscription && !subscription?.defaultStartDate"
          class="mb-4 col-auto"
        >
          <label class="form-label">
            {{ 'general.startDate' | translate }}
          </label>
          <div class="input-group align-items-center">
            <nz-date-picker
              class="form-control"
              data-test-id="subscription-default-start-date"
              [nzDisabledDate]="disabledStartDate"
              formControlName="defaultStartDate"
              [nzPlaceHolder]="'general.startDate' | translate"
              nzFormat="dd/MM/yyyy"
              [nzSize]="'large'"
              [attr.aria-invalid]="startDateErrorString ? 'true' : null"
            ></nz-date-picker>
          </div>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="startDateErrorString"
          >
            {{ startDateErrorString | translate }}
          </p>
        </div>

        <div
          *ngIf="
            subscription &&
            !(subscription?.defaultEndDate || subscription?.defaultStartDate) &&
            !subscription.isAutoRenew
          "
          class="mb-4 col-auto"
        >
          <label id="endDateId" class="form-label">
            {{ 'general.endDate' | translate }}
          </label>
          <div class="input-group align-items-center">
            <input
              aria-labelledby="endDateId"
              class="form-control-plaintext"
              disabled
              value="{{
                subscriptionService.getFormattedEndDate(
                  this.form.controls.defaultStartDate.value,
                  subscription
                )
              }}"
            />
          </div>
        </div>

        <div
          *ngIf="
            subscription &&
            !subscription.defaultStartDate &&
            subscription.defaultEndDate
          "
          class="mb-4 col-auto"
        >
          <label id="endDateFormControlId" class="form-label">
            {{ 'general.endDate' | translate }}
          </label>
          <div class="input-group align-items-center">
            <input
              aria-labelledby="endDateFormControlId"
              class="form-control"
              disabled
              value="{{
                (subscription?.defaultEndDate | momentParse)?.toDate()
                  | date: 'dd/MM/yyyy'
              }}"
            />
          </div>
        </div>
      </div>
      <ng-container
        *ngIf="
          subscription &&
          !(
            (sameSubscriptionSubscriber$ | async) &&
            subscription?.defaultStartDate
          )
        "
      >
        <fieldset
          *ngIf="
            subscription &&
            (subscription.ageLimitMin ||
              subscription.prerequisiteSubscriptions?.length)
          "
          class="mb-4"
        >
          <legend class="h4">
            {{ 'general.conditions' | translate }}
          </legend>
          <div *ngIf="subscription.ageLimitMin" class="mb-2">
            {{ 'general.minAge' | translate }}:
            {{ subscription.ageLimitMin }}
          </div>
          <div *ngIf="subscription.prerequisiteSubscriptions?.length">
            <label class="form-label">{{
              'saleModule.prerequisiteSubscriptions' | translate
            }}</label>
            <subscription-list
              [member]="customerPerson$ | async"
              [subscriptionIds]="subscription.prerequisiteSubscriptions"
              [configOption]="configOption"
              [orgCategoryByUserRole]="orgCategoryByUserRole"
            >
            </subscription-list>
          </div>
        </fieldset>

        <fieldset
          *ngIf="subscription && subscription.linkedSubscriptions?.length"
          class="mb-4"
        >
          <legend class="h4">
            {{ 'saleModule.related' | translate }}
          </legend>
          <div *ngIf="subscription.linkedSubscriptions?.length">
            <label class="form-label"
              >{{ 'saleModule.allowedSubscriptions' | translate }}:</label
            >
            <subscription-list
              [member]="customerPerson$ | async"
              [subscriptionIds]="subscriptionIds"
              [configOption]="configOption"
              [orgCategoryByUserRole]="orgCategoryByUserRole"
            >
            </subscription-list>
          </div>
        </fieldset>
        <div
          class="form-check form-switch"
          [hidden]="!subscription || (subscription && !subscription.termsUrl)"
        >
          <input
            aria-labelledby="generalTermsId"
            type="checkbox"
            class="form-check-input"
            [checked]="false"
            formControlName="generalTerms"
            [attr.aria-invalid]="
              form.controls.generalTerms.dirty &&
              form.controls.generalTerms.invalid
                ? 'true'
                : null
            "
          />
          <label
            id="generalTermsId"
            class="form-check-label"
            data-test-id="accept-general-terms-switch"
          >
            {{ 'memberModule.herebyAccept' | translate }}
            <a
              *ngIf="subscription"
              [href]="subscription.termsUrl"
              target="_blank"
            >
              {{
                (selectedLanguage$ | async) == 'de'
                  ? ('general.generalTerms' | translate)
                  : ('general.generalTerms' | translate)
              }}
              *
            </a>
          </label>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.generalTerms.dirty &&
              form.controls.generalTerms.invalid
            "
          >
            {{ 'saleModule.pleaseAcceptTheGeneralTerms' | translate }}
          </p>

          <!-- End Checkbox Switch -->
        </div>
      </ng-container>
    </div>
    <div
      role="alert"
      aria-atomic="true"
      *ngIf="!isAvailable"
      class="alert alert-warning"
    >
      {{ isNotAvailableText | translate }}
    </div>
  </div>

  <!-- customer category form control    -->
  <div
    class="mb-4"
    *ngIf="
      (!customerCategoryId || customerCategoryId == 0) && chooseCategoryAllowed$
        | async
    "
  >
    <label class="form-label">
      {{ 'saleModule.customerCategory' | translate }}
    </label>
    <select formControlName="customerCategory" class="form-select">
      <option
        *ngFor="let cat of this.categories$ | async"
        value="{{ getCategoryValue(cat) }}"
      >
        {{ cat | getCategoryDescription | async }}
      </option>
    </select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.customerCategory.dirty &&
        form.controls.customerCategory.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'saleModule.customerCategory' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>
</form>
